module.exports = __webpack_public_path__ + "static/img/horror-hand-v2.fcd6244a.png";